/**
 * Closes the mobile header drawer when tapping outside the navigation panel
 * and prevents the interaction from reaching the page behind the overlay.
 */
(function () {
  const binding = {
    closeHandler: null,
    blockClickHandler: null,
    closeEventType: null,
    overlayHandler: null,
    overlay: null,
  };

  function teardownOutsideClick() {
    if (binding.closeHandler && binding.closeEventType) {
      document.removeEventListener(binding.closeEventType, binding.closeHandler, true);
    }
    if (binding.blockClickHandler) {
      document.removeEventListener('click', binding.blockClickHandler, true);
    }
    if (binding.overlay && binding.overlayHandler) {
      binding.overlay.removeEventListener(binding.closeEventType, binding.overlayHandler);
    }

    binding.closeHandler = null;
    binding.blockClickHandler = null;
    binding.closeEventType = null;
    binding.overlayHandler = null;
    binding.overlay = null;
  }

  function initMenuDrawerOutsideClick() {
    teardownOutsideClick();

    const headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    const details =
      headerDrawer.querySelector('#Details-menu-drawer-container') ||
      headerDrawer.querySelector('.menu-drawer-container');
    const summary = details?.querySelector('summary');
    const navContainer = headerDrawer.querySelector('.menu-drawer__navigation-container');
    const menuDrawer = headerDrawer.querySelector('#menu-drawer');
    const overlay = headerDrawer.querySelector('.menu-drawer__overlay');

    if (!details || !summary || !navContainer) return;

    binding.closeEventType = typeof window.PointerEvent === 'function' ? 'pointerdown' : 'click';
    binding.overlay = overlay;

    function isDrawerOpen() {
      return details.hasAttribute('open') && details.classList.contains('menu-opening');
    }

    function isDrawerClosingOrClosed() {
      return !details.hasAttribute('open');
    }

    function isMenuToggle(target) {
      return target instanceof Node && summary.contains(target);
    }

    function isInsideNavContainer(target) {
      return target instanceof Node && navContainer.contains(target);
    }

    function isInsideMenuDrawer(target) {
      return target instanceof Node && menuDrawer?.contains(target);
    }

    function shouldCloseFromTarget(target) {
      if (!(target instanceof Node)) return false;
      if (isMenuToggle(target)) return false;
      return !isInsideNavContainer(target);
    }

    function stopEvent(event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    function closeDrawer(event) {
      if (typeof headerDrawer.closeMenuDrawer === 'function') {
        headerDrawer.closeMenuDrawer(event, summary);
      } else {
        summary.click();
      }
    }

    function handleCloseInteraction(event) {
      if (!isDrawerOpen()) return;

      const target = event.target;
      if (overlay?.contains(target)) return;
      if (!shouldCloseFromTarget(target)) return;

      stopEvent(event);
      closeDrawer(event);
    }

    function blockClickThrough(event) {
      if (binding.closeEventType !== 'pointerdown') return;
      if (isDrawerClosingOrClosed()) return;

      const target = event.target;
      if (!(target instanceof Node)) return;
      if (isMenuToggle(target) || isInsideNavContainer(target)) return;
      if (isInsideMenuDrawer(target) || overlay?.contains(target)) return;

      stopEvent(event);
    }

    binding.closeHandler = handleCloseInteraction;
    document.addEventListener(binding.closeEventType, binding.closeHandler, true);

    if (binding.closeEventType === 'pointerdown') {
      binding.blockClickHandler = blockClickThrough;
      document.addEventListener('click', binding.blockClickHandler, true);
    }

    if (overlay) {
      binding.overlayHandler = function (event) {
        if (!isDrawerOpen()) return;
        stopEvent(event);
        closeDrawer(event);
      };
      overlay.addEventListener(binding.closeEventType, binding.overlayHandler);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuDrawerOutsideClick);
  } else {
    initMenuDrawerOutsideClick();
  }

  document.addEventListener('shopify:section:load', initMenuDrawerOutsideClick);
  document.addEventListener('shopify:section:unload', teardownOutsideClick);
})();
